import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import ExplorePageContainer from '../containers/ExplorePageContainer';

export default function Explore() {
  return (
    <BrowserRouter>
      <Route path="/explore">
        <Switch>
          <Route exact path="/explore" component={ExplorePageContainer} />
          <Route
            exact
            path="/explore/:breedCategorySlug"
            component={ExplorePageContainer}
          />
          <Route
            exact
            path="/explore/:breedCategorySlug/:breedSlug"
            component={ExplorePageContainer}
          />
        </Switch>
      </Route>
    </BrowserRouter>
  );
}
